import React from "react";
import { PermissionRole } from "../utils/roleAuth.utils";

export enum PageNames {
  ORG = "/org",
  COLLABORATORS = "/collaborators",
  POTENTIAL_MATRIX = "/potential-matrix",
  POTENTIAL_MATRIXV3 = "/potential-matrixv3",
  AREA_DEVELOPMENT = "/development-area",
  FAQ = "/faq",
  FORMATION = "/formation",
  MANAGEMENT = "/management",
  TECH_SKILLS = "/tech-skills",
  CAREER_MANAGER = "/career-manager",
  PERSONAL_PROFILE = "/personal-profile",
  PRIVACY_POLICY = "/privacy-policy",
  PAGE_ERROR_403 = "/error-403",
  PAGE_MAINTENANCE = "/maintenance",
  PAGE_ERROR_401 = "/error-401",
  PAGE_ERROR_NOT_DESKTOP = "/error-not-desktop",
}

export enum AppEnvironment {
  DEV = "dev",
  PROD = "prod",
}

export interface SidebarItems {
  icon: React.ReactNode;
  label: string;
  link: PageNames | (() => void);
  permission: PermissionRole;
}
export enum DimensionsEnum {
  BIG = "big",
  SMALL = "small",
  X_SMALL = "x_small",
  XX_SMALL = "xx_small",
  FIT_CONTENT = "fit_content",
}
export enum IconSizeEnum {
  XSMALL = "xsmall",
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export enum FileUploaderSizeEnum {
  REGULAR = "regular",
  LARGE = "large",
}

export enum Role {
  ADMIN = "ADMIN",
  HR = "HR",
  A_LEADER = "A_LEADER",
  P_MANAGER = "P_MANAGER",
  P_LEADER = "P_LEADER",
  CC_MANAGER = "CC_MANAGER",
  CC_LEADER = "CC_LEADER",
  COLLABORATOR = "COLLABORATOR",
}
export enum FontWeightEnum {
  SEMIBOLD = "semiBold",
  MEDIUM = "medium",
  REGULAR = "regular",
}
export enum DirectionEnum {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}
export enum AlignmentEnum {
  START = "flex-start",
  CENTER = "center",
  END = "flex-end",
}
export enum AuthPaths {
  LOGOUT = "/oauth2/authenticate/azure",
}

export enum CollaboratorsFiltersEnum {
  FORMATION = "formation",
  CM_STATE = "cmState",
  RELATION = "relation",
  ORG = "org",
  FEATURES = "features",
  RELATION_CM_SHEET = "relationCmSheet",
  TECH_SKILLS = "techSkills",
}

export enum CoursesFiltersEnum {
  FEATURE = "features",
  ORG = "org",
}

export enum CertificationsFiltersEnum {
  FEATURE = "features",
  ORG = "org",
}

export enum CareerManagersFiltersEnum {
  ORG = "org",
  RELATION = "relation",
}

export enum CollaboratorHistoryProjectsFiltersEnum {
  TIMELINE = "timeline",
  DETAILS = "details",
}

export type TabMenu = {
  id: number;
  label: string;
  icon: React.JSX.Element | null;
};

export type FilterProps = {
  key: string;
  value: (string | number)[];
};

export type CollaboratorInfo = {
  id: number;
  name: string;
  surname: string;
  area: string | null;
  practice: string | null;
  cc: string | null;
  internalGrade: string | null;
  careerManagerFullName: string | null;
};

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type WithOptional<T, K extends keyof T> = Omit<T, K> &
  Partial<Pick<T, K>>;

export type BreadcrumbItem = {
  name: string;
  pathName: string | null;
};

export type ManagementTableRow<T> = {
  id: number;
  item: T;
};

export enum TechSkillPropertyEnum {
  COMPETENCE = "COMPETENCE",
  STREAM = "STREAM",
  SOFTWARE = "SOFTWARE",
  COMPONENT = "COMPONENT",
}

export enum TechSkillsFilterPropertyEnum {
  COMPETENCE = "competence",
  STREAM = "stream",
  SOFTWARE = "software",
  COMPONENT = "component",
}

export enum OrganizationPropertyEnum {
  PRACTICE = "PRACTICE",
  CC = "CC",
}
export enum OrganizationFilterPropertyEnum {
  PRACTICE = "practice",
  CC = "cc",
}

export const TechSkillsFilterPropertyMap = {
  [TechSkillsFilterPropertyEnum.COMPETENCE]: TechSkillPropertyEnum.COMPETENCE,
  [TechSkillsFilterPropertyEnum.STREAM]: TechSkillPropertyEnum.STREAM,
  [TechSkillsFilterPropertyEnum.SOFTWARE]: TechSkillPropertyEnum.SOFTWARE,
  [TechSkillsFilterPropertyEnum.COMPONENT]: TechSkillPropertyEnum.COMPONENT,
};

export const OrganizationFilterPropertyMap = {
  [OrganizationFilterPropertyEnum.PRACTICE]: OrganizationPropertyEnum.PRACTICE,
  [OrganizationFilterPropertyEnum.CC]: OrganizationPropertyEnum.CC,
};
export enum TechSkillModalMode {
  ADD_TECH_SKILL = "ADD_TECH_SKILL",
  ATTACH = "ATTACH",
}
